import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthService } from '../Service/auth.service';
import { SharedConstants } from '../models/shared/shared.constants';


@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private readonly authService: AuthService,
        private readonly constants: SharedConstants) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const baseUrl = this.constants.getApiServer();
        const currentUser = this.authService.currentUserValue;
        let fileConfig = request.url.startsWith("/assets/config/config.json");
        let fileLanguage = request.url.startsWith("/assets/i18n/");
        let uploadFile = request.url.startsWith("/identitum-api/bulk");

        if (!fileConfig && !fileLanguage) {
            if (currentUser && currentUser.token) {
                if (uploadFile) {
                    request = request.clone({
                        url: baseUrl + request.url,
                        setHeaders: {
                            Authorization: `Bearer ${currentUser.token}`
                        }
                    });
                }
                else {
                    request = request.clone({
                        url: baseUrl + request.url,
                        setHeaders: {
                            Authorization: `Bearer ${currentUser.token}`,
                            'content-type': 'application/json',
                        }
                    });
                }
            } else {
                request = request.clone({
                    url: baseUrl + request.url,
                    setHeaders: {
                        'content-type': 'application/json',
                    }
                });
            }
        }
        return next.handle(request);
    }
}
